module.exports = __webpack_public_path__ + "static/media/M1-25-Ertus-Desgarrada-cod134.72574d2a.png";